import type { TFonts } from '@lib/utils/fonts'

// Object.freeze allows this to act like an enum while being a complex object
export const Fonts: TFonts = Object.freeze({
  // @TODO: Switch out all otf files for woff2 files when available
  'Super Sans': {
    400: {
      normal: {
        otf: 'SuperSans-Regular.otf',
      },
      // Italic example
      // italic: {
      //   otf: 'SuperSans-RegularItalic.otf',
      // },
    },
    500: {
      normal: {
        otf: 'SuperSans-Medium.otf',
      },
    },
  },
  'Super Sans Mono': {
    400: {
      normal: {
        otf: 'SuperSans-Regular.otf',
      },
    },
  },
  'Super Serif': {
    400: {
      normal: {
        otf: 'SuperSerif-Regular.otf',
      },
      italic: {
        otf: 'SuperSerif-RegularItalic.otf',
      },
    },
    580: {
      normal: {
        otf: 'SuperSerif-SemiBold.otf',
      },
    },
  },
})
